export default "__VITE_ASSET__b18652f4__"